import React, {
  Fragment,
  useEffect,
  useLayoutEffect,
  useState,
  useContext,
} from 'react';
import { withTranslation } from 'react-i18next';
import { reduxForm, Field, clearFields } from 'redux-form';
import { ButtonToolbar, Button, Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import validate from '../Validate';
import renderField from '../../../../shared/components/form/RenderField';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../../redux/actions/loadingActions';
import Select from '../../../../shared/components/form/Select';
import renderCheckBoxField from '../../../../shared/components/form/CheckBox';
import { currencyMasker } from '../../../../shared/components/form/Masks';
import DateField from '../../../../shared/components/form/DateField';
import TextAreaField from '../../../../shared/components/form/TextAreaField';
import FullScreenDialog from '../../../../shared/components/FullScreenDialog';
import GraphQl from '../../../../GraphQL';
import { showNotificationAutoDestroy } from '../../../../shared/components/ShowNotification';
import {
  accountList,
  categoryList,
  discountConfigurationByAccount,
  discountConfigurationByTitle,
  paymentFrequencyListByFilter,
  responsibleFinancialContactByStudent,
  studentListByFilter,
} from '../../../../shared/queries/AccountsReceivableAndPayable';
import TableNav from './TableNav';
import DiscontConfigurationForm from './DiscontConfiguration';
import {
  STATUS_CANCELED,
  SMART_BABY_USER,
  STATUS_OPENED,
} from '../../../../shared/utils/constants';
import SmartContext from '../../../App/context/SmartContext';

const Form = (props) => {
  const {
    t,
    dispatch,
    change,
    backHandler,
    handleSubmit,
    dto,
    findById,
    initialize,
    financialCancel,
  } = props;

  const [repeat, setRepeat] = useState(false);
  const [isSmartPay, setIsSmartPay] = useState(false);
  const [automaticBilling, setAutomaticBilling] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [students, setStudents] = useState([]);
  const [responsibles, setResponsibles] = useState([]);
  const [frequencyList, setFrequencyList] = useState([]);
  const [discontConfigurationForm, setDiscontConfigurationForm] =
    useState(false);
  const [discountConfigurations, setDiscountConfigurations] = useState([]);
  const [applyDiscountConfigurations, setApplyDiscountConfigurations] =
    useState(false);
  const context = useContext(SmartContext);
  const { loggedUser } = context;

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const compareCategory = (cat) => {
    if (dto.id !== 0) {
      const updateCategory = cat.id !== dto.category.id;
      change('updateCategory', updateCategory);
    }
  };

  const compareDescription = (description) => {
    if (dto.id !== 0) {
      const updateDescription = description !== dto.description;
      change('updateDescription', updateDescription);
    }
  };

  const compareObservation = (observation) => {
    if (dto.id !== 0) {
      const updateObservation = observation !== dto.obs;
      change('updateObservation', updateObservation);
    }
  };

  const compareCompetence = (competence) => {
    if (dto.id !== 0) {
      const updateCompetence =
        competence.getTime() !== dto.competencyDate.getTime();
      change('updateCompetence', updateCompetence);
    }
  };

  const compareDueDate = (dueDate) => {
    if (dto.id !== 0) {
      const updateDueDate = dueDate.getTime() !== dto.dueDate.getTime();
      change('updateDueDate', updateDueDate);
    }
  };

  const compareValue = (value) => {
    const valueReplace = value.replace(/[^0-9]+/g, '');
    const valueFormated = parseFloat(valueReplace.replace(/\.?0+$/, ''));
    if (dto.id !== 0) {
      const updateValue = valueFormated !== dto.value;
      change('updateValue', updateValue);
    }
  };

  const loadAllAccount = () => {
    const query = accountList();
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        res.accountListByFilter = res.accountListByFilter.map((item) => ({
          ...item,
          value: item.id,
          label: item.name,
        }));
        setAccounts(res.accountListByFilter);
        hideLoading();
      })
      .catch((error) => {
        hideLoading();
        console.error(error);
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.error-to-loading')
        );
      });
  };

  const loadAllCategory = () => {
    const query = categoryList();
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        res.receivingCategoryListByFilter =
          res.receivingCategoryListByFilter.map((item) => ({
            ...item,
            id: item.id,
            value: item.id,
            label: item.name,
          }));
        setCategories(res.receivingCategoryListByFilter);
        hideLoading();
      })
      .catch((error) => {
        hideLoading();
        console.error(error);
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.error-to-loading')
        );
      });
  };

  const loadStudents = () => {
    showLoading();
    const filter = {
      id: 0,
      classes: [],
      responsibles: [],
      menus: [],
      onlyActive: true,
    };
    const query = studentListByFilter(filter);
    GraphQl(query, {})
      .then((res) => {
        res.studentListByFilter = res.studentListByFilter.map((item) => ({
          ...item,
          value: item.id,
          label: `${item.fullName} ${
            item.classesNames ? `- ${item.classesNames}` : ''
          }`,
        }));
        setStudents(res.studentListByFilter);
        hideLoading();
      })
      .catch((error) => {
        hideLoading();
        console.error(error);
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.error-to-loading')
        );
      });
  };

  const loadResponsibleFinancial = (studentId) => {
    showLoading();
    const query = responsibleFinancialContactByStudent(studentId);
    GraphQl(query, {})
      .then((res) => {
        res.responsibleFinancialContactByStudent =
          res.responsibleFinancialContactByStudent.map((item) => ({
            ...item,
            value: item.id,
            label: item.fullName,
          }));
        setResponsibles(res.responsibleFinancialContactByStudent);
        hideLoading();
      })
      .catch((error) => {
        hideLoading();
        console.error(error);
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.error-to-loading')
        );
      });
  };

  const loadFrequencyList = () => {
    showLoading();
    const query = paymentFrequencyListByFilter();
    GraphQl(query, {})
      .then((res) => {
        res.paymentFrequencyListByFilter = res.paymentFrequencyListByFilter.map(
          (item) => ({
            ...item,
            value: item.id,
            label: item.name,
          })
        );
        setFrequencyList(res.paymentFrequencyListByFilter);
        hideLoading();
      })
      .catch((error) => {
        hideLoading();
        console.error(error);
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.error-to-loading')
        );
      });
  };

  const toggleDiscontConfigurationForm = () => {
    setDiscontConfigurationForm(!discontConfigurationForm);
  };

  const loadDiscountConfigurationByTitle = (titleId) => {
    showLoading();
    const query = discountConfigurationByTitle(titleId);
    GraphQl(query, {})
      .then((res) => {
        res.discountConfigurationByTitle = res.discountConfigurationByTitle.map(
          (item) => ({
            ...item,
          })
        );
        setDiscountConfigurations(res.discountConfigurationByTitle);
        hideLoading();
      })
      .catch((error) => {
        hideLoading();
        console.error(error);
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.error-to-loading')
        );
      });
  };

  const loadDiscountConfigurationByAccount = (accountId) => {
    showLoading();
    const query = discountConfigurationByAccount(accountId);
    GraphQl(query, {})
      .then((res) => {
        res.discountConfigurationByAccount =
          res.discountConfigurationByAccount.map((item) => ({
            ...item,
            titleId: 0,
          }));
        setDiscountConfigurations(res.discountConfigurationByAccount);
        if (!res.discountConfigurationByAccount.length) {
          change('applyDiscountConfiguration', false);
        }
        hideLoading();
      })
      .catch((error) => {
        hideLoading();
        console.error(error);
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.error-to-loading')
        );
      });
  };

  const validateSmartPayAccount = (value) => {
    if (value) {
      const smartPayAccount = accounts.filter((acc) => acc.smartpay);
      if (smartPayAccount[0]) {
        setIsSmartPay(true);
        change('fines', smartPayAccount[0].iuguAccountInfo.interestForDelay);
        change('applyDiscountConfiguration', true);
        change(
          'perDayInterest',
          smartPayAccount[0].iuguAccountInfo.dailyInterestForDelay
        );
        change(
          'latePaymentFine',
          smartPayAccount[0].iuguAccountInfo.interestRateForDelay
        );
        if (dto.id === 0) {
          loadDiscountConfigurationByAccount(smartPayAccount[0].id);
        }
      } else {
        setIsSmartPay(false);
        setAutomaticBilling(!automaticBilling);
        showNotificationAutoDestroy(
          'danger',
          t('warnings.title'),
          t('notifications.your-smartpay-account-not-use')
        );
      }
      change('account', smartPayAccount[0]);
    } else {
      setIsSmartPay(false);
      dispatch(clearFields('ReceivableForm', true, true, ...['account']));
    }
  };

  const accountChange = (value) => {
    const { id, smartpay, iuguAccountInfo } = value;
    if (smartpay) {
      if (iuguAccountInfo) {
        change('automaticBilling', true);
        if (dto.id === 0) {
          change('fines', iuguAccountInfo.interestForDelay);
          change('applyDiscountConfiguration', true);
          change('perDayInterest', iuguAccountInfo.dailyInterestForDelay);
          change('latePaymentFine', iuguAccountInfo.interestRateForDelay);
          loadDiscountConfigurationByAccount(id);
        }
      } else if (dto.id === 0) {
        showNotificationAutoDestroy(
          'danger',
          t('warnings.title'),
          t('notifications.your-smartpay-account-not-use')
        );
      }
      setIsSmartPay(!isSmartPay);
    }
  };

  const changeDiscountConfigurations = (list, changed) => {
    if (changed) {
      setDiscountConfigurations(list);
      change('updateDiscount', changed);
    }
    let apply = false;
    if (list.length) {
      apply = true;
    }
    change('applyDiscountConfiguration', apply);
    toggleDiscontConfigurationForm();
  };

  const responsibleByStudentId = (value) => {
    if (value) {
      const { id } = value;
      loadResponsibleFinancial(id);
    }
  };

  const validateLength = (checked) => {
    if (checked && !discountConfigurations.length) {
      showNotificationAutoDestroy(
        'warning',
        t('warnings.title'),
        t('notifications.without-discount-configuration')
      );
      setApplyDiscountConfigurations(!applyDiscountConfigurations);
    }
  };

  useEffect(() => {
    if (!discountConfigurations.length) {
      change('applyDiscountConfiguration', false);
    }
  }, [applyDiscountConfigurations]);

  useEffect(() => {
    dispatch(
      clearFields('ReceivableForm', true, true, ...['automaticBilling'])
    );
  }, [automaticBilling]);

  useEffect(() => {
    change('discountConfigurations', discountConfigurations);
  }, [discountConfigurations]);

  useEffect(() => {
    initialize(dto);
    if (dto.account) {
      accountChange(dto.account);
    }
    if (dto.id !== 0) {
      loadDiscountConfigurationByTitle(dto.id);
    }
  }, [dto]);

  useLayoutEffect(() => {
    dispatch(clearFields('ReceivableForm', true, true, ...['responsible']));
  }, [responsibles]);

  useLayoutEffect(() => {
    change('automaticBilling', false);
  }, [automaticBilling]);

  useEffect(() => {
    loadAllAccount();
    loadAllCategory();
    loadStudents();
    loadFrequencyList();
  }, []);

  return (
    <Fragment>
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group--2_columns">
          <span className="form__form-group-label">{t('general.code')}:</span>
          <span className="bold-text pl-1">{dto.id}</span>
          <span className="form__form-group-label pl-3">
            {t('general.status')}:
          </span>
          <span className="bold-text pl-1">{t(`general.${dto.status}`)}</span>

          {loggedUser &&
            loggedUser.login &&
            loggedUser.login.toUpperCase() === SMART_BABY_USER && (
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <span className="generic__label text-danger">
                    {t('general.test-environment')}
                  </span>
                  <Field
                    name="inTestEnvironment"
                    component={renderCheckBoxField}
                    className="colored-click"
                  />
                </div>
              </div>
            )}
        </div>

        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.category')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="category"
              type="text"
              component={Select}
              options={categories}
              placeholder={t('screens.mnt_receber.placeholders.select')}
              onChange={(value) => compareCategory(value)}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.description')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="description"
              type="text"
              component={TextAreaField}
              maxLength="300"
              placeholder={t('screens.mnt_receber.placeholders.description')}
              onBlur={(event) => compareDescription(event.target.value)}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.note')}</span>
          <div className="form__form-group-field">
            <Field
              name="obs"
              type="text"
              component={TextAreaField}
              maxLength="300"
              placeholder={t('screens.mnt_receber.placeholders.note')}
              onBlur={(event) => compareObservation(event.target.value)}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.account')}</span>
          <div className="form_form-group-field">
            <Field
              name="account"
              type="text"
              component={Select}
              options={accounts}
              isDisabled={dto.status !== STATUS_OPENED || isSmartPay}
              placeholder={t('screens.mnt_receber.placeholders.select')}
              onChange={accountChange}
            />
          </div>
        </div>
        <div className="form__form-group--4_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.value')}</span>
            <div className="form__form-group-field">
              <Field
                name="value"
                type="text"
                maxLength="16"
                component={renderField}
                {...currencyMasker()}
                onBlur={(event) => compareValue(event.target.value)}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.competence')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="competencyDate"
                component={DateField}
                onChange={(value) => compareCompetence(value)}
              />
            </div>
          </div>
          <div className="form__form-group mr-3">
            <span className="form__form-group-label">
              {t('general.due-date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="dueDate"
                component={DateField}
                onChange={(value) => compareDueDate(value)}
              />
            </div>
          </div>
          <div className="form__form-group-field">
            <span className="form__form-group-label pr-2">
              {t('general.generate-billing')}
            </span>
            <Field
              name="automaticBilling"
              component={renderCheckBoxField}
              defaultChecked={automaticBilling}
              className="colored-click"
              disabled={dto.id !== 0}
              onChange={(event) => {
                if (event.target) validateSmartPayAccount(event.target.checked);
              }}
            />
          </div>
        </div>
        <Collapse isOpen={isSmartPay} className="width100">
          <div className="form__form-group--4_columns">
            <div className="form__form-group-field">
              <span className="form__form-group-label pr-2">
                {t('account.penalty')}
              </span>
              <Field
                name="fines"
                component={renderCheckBoxField}
                className="colored-click"
                disabled={dto.id !== 0}
              />
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('account.fine-amount')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="latePaymentFine"
                  type="number"
                  component={renderField}
                  maxLength="2"
                />
              </div>
            </div>
            <div className="form__form-group-field">
              <span className="form__form-group-label pr-2">
                {t('account.interest')}
              </span>
              <Field
                name="perDayInterest"
                component={renderCheckBoxField}
                className="colored-click"
              />
            </div>
            <div className="form__form-group--2_columns d-flex nowrap">
              <div className="form__form-group-field">
                <span className="form__form-group-label pr-2 text-nowrap">
                  {t('general.apply-discount')}
                </span>
                <Field
                  name="applyDiscountConfiguration"
                  component={renderCheckBoxField}
                  className="colored-click"
                  onChange={(event) => {
                    if (event.target) {
                      validateLength(event.target.checked);
                    }
                  }}
                />
              </div>
              <div className="form__form-group-field flex-1">
                <IconButton
                  aria-label="edit"
                  onClick={toggleDiscontConfigurationForm}
                >
                  <EditIcon />
                </IconButton>
              </div>
            </div>
          </div>
        </Collapse>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.student')}</span>
          <div className="form__form-group-field">
            <Field
              name="student"
              type="text"
              component={Select}
              options={students}
              placeholder={t('screens.mnt_receber.placeholders.select')}
              onChange={responsibleByStudentId}
              isDisabled={dto.id !== 0}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.responsible-account')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="responsible"
              type="text"
              component={Select}
              options={responsibles}
              placeholder={t('screens.mnt_receber.placeholders.select')}
              isDisabled={dto.id !== 0}
            />
          </div>
        </div>
        {dto.id === 0 && (
          <div className="form__form-group">
            <div className="form__form-group-field">
              <span className="generic__label"> {t('general.repeat')} </span>
              <Field
                name="indRepeat"
                component={renderCheckBoxField}
                className="colored-click"
                onChange={(event) => {
                  if (event.target) {
                    setRepeat(event.target.checked);
                  }
                }}
              />
            </div>
          </div>
        )}
        <Collapse isOpen={repeat} className="width100">
          <div className="form__form-group">
            <div className="form_form-group-field">
              <Field
                name="paymentFrequency"
                type="text"
                component={Select}
                options={frequencyList}
                placeholder={t('screens.mnt_receber.placeholders.select')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.parcel')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="nupaTitu"
                type="number"
                min="1"
                max="99"
                component={renderField}
                maxLength="50"
                placeholder={t('screens.mnt_receber.placeholders.parcel')}
              />
            </div>
          </div>
        </Collapse>
        {dto.id !== 0 && (
          <div className="form__form-group">
            <TableNav
              idTitle={dto.id}
              valueTitle={dto.value}
              isSmartPay={isSmartPay}
              findById={findById}
            />
          </div>
        )}
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          {dto.id !== 0 && dto.status !== STATUS_CANCELED && (
            <Button color="danger" onClick={financialCancel}>
              {t('general.cancel')}
            </Button>
          )}
          <Button color="success" type="submit">
            {t('general.save')}
          </Button>
        </ButtonToolbar>
      </form>
      <FullScreenDialog
        title={t('panels.discounts-setup')}
        toggleDialog={toggleDiscontConfigurationForm}
        isOpen={discontConfigurationForm}
      >
        <DiscontConfigurationForm
          discountConfigurations={discountConfigurations}
          onConfirm={changeDiscountConfigurations}
          titleId={dto.id}
        />
      </FullScreenDialog>
    </Fragment>
  );
};

Form.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  financialCancel: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  findById: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'ReceivableForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(Form));
